<template>
  <div>
    <b-row>
      <b-col
          md="4"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="4"
          sm="4"
          class="my-1"
      >
      </b-col>

      <b-col
          md="4"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Suche</label>
          <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="z.b. Name, Telefon"
          />
        </b-form-group>
      </b-col>

      <b-col
          md="12"
          xl="12"
      >
        <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
        >
          <template #cell(CallId)="data">
            {{data.item.CallId}}
          </template>
          <template #cell(DateTime)="data">
            {{formatDate(data.item.DateTime)}} (<timeago :datetime="data.item.DateTime" locale="de" :auto-update="60"></timeago>)
          </template>
          <template #cell(DateTime)="data">
            {{formatDate(data.item.DateTime)}} (<timeago :datetime="data.item.DateTime" locale="de" :auto-update="60"></timeago>)
          </template>
          <template #cell(Contact)="data">
            <b-badge
                variant="info"
                v-for="d in data.item.Drivers">
              {{d.Name}}
            </b-badge>
            <b-badge
                variant="success"
                v-for="d in data.item.Addresses">
              {{d.IdentId}} - {{d.Name}}
            </b-badge>
            <b-badge
                variant="secondary"
                v-for="d in data.item.Customer">
              {{d.IdentId}} - {{d.Name}}
            </b-badge>
            <b-badge
                variant="danger"
                v-for="d in data.item.Contacts">
              {{d.IdentId}} - {{d.Name}}
            </b-badge>
          </template>
        </b-table>
      </b-col>

      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem, VBTooltip
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Call',
  components: {
    BCardCode,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'CallId',
          label: 'Anruf Id',
        },
        {
          key: 'DateTime',
          label: 'Zeit',
        },
        {
          key: 'Contact',
          label: 'Kontakt',
        },
        {
          key: 'Number',
          label: 'Telefonnummer',
        },
        {
          key: 'Receiver',
          label: 'Empfänger',
        },
      ],
      items: [],

    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      document.title = 'Anrufliste'
    })
    this.$watch(
        () => this.currentPage,
        val => {
          this.Load();
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.Load()
          }, 550)
        },
    )
    this.Load()
  },

  sockets: {
    incomingCall() {
      this.Load();
    },
  },

  methods: {
    clickCall(record, index) {

    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          },
      )}`
    },
    Load() {
      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/call/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = url+`&filter=${this.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            if (resp.data.success) {
              this.totalRows = resp.data.info.fullEntries
              resp.data.list.forEach(i => {
                this.items.push(i)
              })
            }

          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>
